import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Registration.css";

// Components
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { setUser } from "../../features/auth/authSlice";
import { unsetAccount } from "../../features/registration/registrationSlice";
import { auth, db } from "../../utils/firebase/firebase";

function Registrationpg3() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    email,
    firstName,
    lastName,
    password,
    bDate,
    sex,
    phone,
    province,
    cityTown,
    street,
    zipCode,
    refCode,
    isEighteen,
    hasAgreedToMarketing,
    hasAgreedToTermsAndConditions,
    occupation,
    usage,
  } = useSelector((state) => state.registration);

  const handleSignUp = async (event) => {
    event.preventDefault();
    // todo: make api endpoint for user registration
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        email,
        password
      );

      // console.log(user);

      let refStatus = false;

      if (refCode === "" || refCode === undefined) {
        refStatus = false;
      } else {
        refStatus = true;
      }

      Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };

      var date = new Date();
      const dateMs = date * 1;
      const date90Days = dateMs + 3600000 * 24 * 90;
      // console.log(date.addDays(5));

      await db
        .collection("Users")
        .doc(user.uid)
        .set({
          appInfo: {
            lastAccessDate: "",
            lastIpAddress: "",
          },
          config: {
            dateCreated: new Date(),
            hasAgreedToTermsAndConditions: hasAgreedToTermsAndConditions,
            hasAgreedToMarketing: hasAgreedToMarketing,
            isEmailVerified: false,
            isMobileVerified: false,
            memberExpiry: new Date(date90Days),
            status: "pending",
            withReferral: refStatus,
          },
          details: {
            address: {
              cityTown: cityTown,
              province: province,
              streetAddress: street,
              zipCode: zipCode,
            },
            dateOfBirth: bDate,
            email: email,
            firstName: firstName,
            fullName: firstName + " " + lastName,
            lastName: lastName,
            mobile: phone,
            sex: sex,
            isAtleastEighteen: isEighteen,
          },
          usageData: { occupation: occupation, usage: usage },
          settings: {
            id: {
              link: "",
              type: "Id Type",
              uploadDate: "",
            },
            photo: "",
            referralCode: refCode,
            userType: "user",
          },
        });
      dispatch(
        setUser({
          email: user.email,
          uid: user.uid,
        })
      );
      dispatch(unsetAccount());
      navigate("/");
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <>
      <Grid container spacing={2} direction="row" justifyContent="center">
        <Grid item xs="auto" sx={{ marginLeft: "5rem" }}>
          <Box className="card card--left">
            <Box className="card">
              <Box>
                <h1 className="card__title">Welcome to Tuos</h1>
              </Box>
              <Box>
                <Box mt="1.5em" />
                <p className="card__text">
                  In order to proceed with the platform, we would to get to know
                  you better.
                </p>
                <Box mt="1.5em" />
                <p className="card__text">This will only take 1 - 2mins.</p>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs="auto">
          <Box className="card card--right">
            <Box
              className="card"
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
            >
              <Button
                variant="contained"
                className="registration__button"
                onClick={handleSignUp}
              >
                Create Account
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default Registrationpg3;
